import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import myPic from '../images/stivan.jpg';
import macbookPic from '../images/macbook.png';
import codeskillsPic from '../images/codeface.png';

//Images for Technologies Section
import js_logo from '../images/tech_logos/js_logo.png';
import jquery_logo from '../images/tech_logos/jquery_logo.png';
import react_logo from '../images/tech_logos/react_logo.png';
import nodejs_logo from '../images/tech_logos/nodejs_logo.png';
import html_logo from '../images/tech_logos/html_logo.png';
import css_logo from '../images/tech_logos/css_logo.png';
import bootstrap_logo from '../images/tech_logos/bootstrap_logo.png';
import aws_logo from '../images/tech_logos/aws_logo.png';
import python_logo from '../images/tech_logos/python_logo.png';
import mysql_logo from '../images/tech_logos/mysql_logo.png';
import sybase_logo from '../images/tech_logos/sybase_logo.png';
import powerbuilder_logo from '../images/tech_logos/powerbuilder_logo.png';


class Homepage extends Component {
    render() {
        return (
            <div className="wrap">
                <div id="homepage_banner" class="jumbotron text-center">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                            <div class="zoom">
                                <i id="homepage_icons" class="fa fa-tachometer"></i>
                                <h3 id="homepage_icon_text">Fast</h3>
                                <p id="homepage_icon_text"><small>Seamless interaction and fast <br></br>load times, my highest priority.</small></p>
                            </div>
                            <div class="zoom">
                                <i id="homepage_icons" class="fa fa-lightbulb-o"></i>
                                <h3 id="homepage_icon_text">API</h3>
                                <p id="homepage_icon_text"><small>Strong preference for creating web apps<br></br> that communicate with computers.</small></p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <h1 id="white_background_text">Stivan Kitchoukov</h1>
                            <p id="white_background_text">Software Engineer</p>
                            <img src={myPic} class="rounded-circle" alt="Stivan Kitchoukov" width="300" height="300"></img>
                        </div>
                        <div class="col-md-4">
                            <div class="zoom">
                                <i id="homepage_icons" class="material-icons">security</i>
                                <h3 id="homepage_icon_text">Secure</h3>
                                <p id="homepage_icon_text"><small>My software is created <br></br>and tested with latest security.</small></p>
                            </div>
                            <div class="zoom">
                                <i id="homepage_icons" class="fa fa-space-shuttle"></i>
                                <h3 id="homepage_icon_text">Dynamic</h3>
                                <p id="homepage_icon_text"><small>Websites don't have to be static, I love<br></br> making pages come to life.</small></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="homepage_content">
                    {/*<div class="container-fluid">
                        <div class="row align-items-center">
                            <div class="col-sm-12">
                                <div class="triangle-down"></div>
                            </div>
                        </div>
                    </div>*/}
                    <div id="homepage_content" class="jumbotron text-center"> 
                        <div class="row align-items-center">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-5">
                                <img src={macbookPic} width="220" height="196"></img>
                            </div>
                            <div class="col-sm-5">
                                <h3  id="homepage_title_text">
                                    I'm currently working at STS, a software company in Stroudsburg, Pennsylvania. 
                                </h3>
                                <p id="homepage_icon_text"><small>
                                    I am passionate about building software that improves peoples everyday tasks. 
                                    I specialize in creating financial software for clients ranging from start-ups to large enterprise corporations.
                                    My work is produced locally from Stroudsburg, Pennsylvania.
                                </small></p>
                                <Link to="/Contact"><b>Let's Make something together!</b></Link>
                            </div>
                            <div class="col-sm-1"></div>
                        </div>
                    </div>
                     
                </div>

                {/*Technical Skills*/}
                <div id="homepage_skills" class="jumbotron text-center">
                    <div class="row align-items-center">
                        <div class="col-sm-12">
                            <h1 id="white_background_text">Technical Skills</h1>
                            <hr id="standard_line"></hr>
                            <br></br>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-sm-1"></div>
                        <div class="col-sm-6">
                            <img id="img_codeskills" src={codeskillsPic} width="400" height="366"></img>
                        </div>
                        <div class="col-sm-4">
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"85%"}}><h6 id="progress-bar-title">CSS</h6></div>
                                <span id="progress-bar-percent">85%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"90%"}}><h6 id="progress-bar-title">HTML</h6></div>
                                <span id="progress-bar-percent">90%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"90%"}}><h6 id="progress-bar-title">Python</h6></div>
                                <span id="progress-bar-percent">90%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"95%"}}><h6 id="progress-bar-title">JavaScript</h6></div>
                                <span id="progress-bar-percent">95%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"85%"}}><h6 id="progress-bar-title">React</h6></div>
                                <span id="progress-bar-percent">85%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"80%"}}><h6 id="progress-bar-title">Node</h6></div>
                                <span id="progress-bar-percent">80%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"95%"}}><h6 id="progress-bar-title">SQL</h6></div>
                                <span id="progress-bar-percent">95%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"80%"}}><h6 id="progress-bar-title">C++</h6></div>
                                <span id="progress-bar-percent">80%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"85%"}}><h6 id="progress-bar-title">PHP</h6></div>
                                <span id="progress-bar-percent">85%</span>
                            </div>
                            <br></br>
                            <div class="progress border">
                                <div class="progress-bar bg-info" style={{width:"95%"}}><h6 id="progress-bar-title">PowerBuilder</h6></div>
                                <span id="progress-bar-percent">95%</span>
                            </div>
                        </div>
                        <div class="col-sm-1"></div>
                    </div>
                </div>
                
                {/*Services*/}
                <div id="homepage_content" class="jumbotron text-center">
                    <div class="row align-items-center">
                        <div class="col-sm-12">
                            <h1 id="white_background_text">Services</h1>
                            <hr id="standard_line"></hr>
                            <br></br>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-desktop"></i>
                                    <h3 class="card-title service_title">Web Design</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-tasks"></i>
                                    <h3 class="card-title service_title">Automation</h3>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-bug"></i>
                                    <h3 class="card-title service_title">Web Scraping</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-line-chart"></i>
                                    <h3 class="card-title service_title">SEO</h3>
                                </div>
                            </div>
                        </div>
                 
                    </div>
                    <div class="row align-items-center">
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-cloud"></i>
                                    <h3 class="card-title service_title">Hosting</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-file-code-o"></i>
                                    <h3 class="card-title service_title">Web Apps</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-users"></i>
                                    <h3 class="card-title service_title">Consulting</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 service_row">
                            <div class="card service_card">
                                <div class="card-block service_block">
                                    <i id="services_icons" class="fa fa-database"></i>
                                    <h3 class="card-title service_title">Optimization</h3>
                                </div>
                            </div>
                        </div>
                 
                    </div>
                </div>

                {/*Technologies*/}
                <div id="homepage_skills" class="jumbotron text-center">
                    <div class="row align-items-center">
                        <div class="col-md-12">
                            <h1 id="white_background_text">Technologies</h1>
                            <hr id="standard_line"></hr>
                            <br></br>
                        </div>
                    </div>

                    {/*1st Row of Logos*/}
                    <div class="row align-items-center">
                        <div class="col-sm-3 homepage_logo">
                            <img src={js_logo} width="100" height="141" alt="JavaScript"></img>
                        </div>
                        <div class="col-sm-3 homepage_logo">
                            <img src={jquery_logo} width="100" height="23" alt="jQuery"></img>
                        </div>
                        <div class="col-sm-3 homepage_logo">
                            <img src={react_logo} width="100" height="89" alt="ReactJs"></img>
                        </div>
                        
                        <div class="col-sm-3 homepage_logo">
                            <img src={nodejs_logo} width="100" height="61" alt="NodeJS"></img>
                        </div>
                    </div>

                    {/*2nd Row of Logos*/}
                    <div class="row align-items-center">
                        <div class="col-sm-3 homepage_logo">
                            <img src={html_logo} width="100" height="141" alt="HTML"></img>
                        </div>
                        <div class="col-sm-3 homepage_logo">
                            <img src={css_logo} width="100" height="141" alt="CSS"></img>
                        </div>
                        <div class="col-sm-3 homepage_logo">
                            <img src={bootstrap_logo} width="100" height="129" alt="Bootstrap"></img>
                        </div>
                        
                        <div class="col-sm-3 homepage_logo">
                            <img src={aws_logo} width="100" height="60" alt="Amazon Web Services"></img>
                        </div>
                    </div>

                    {/*3rd Row of Logos*/}
                    <div class="row align-items-center">
                        <div class="col-sm-3 homepage_logo">
                            <img src={python_logo} width="100" height="114" alt="Python"></img>
                        </div>
                        <div class="col-sm-3 homepage_logo">
                            <img src={mysql_logo} width="100" height="52" alt="MySQL"></img>
                        </div>
                        <div class="col-sm-3 homepage_logo">
                            <img src={sybase_logo} width="100" height="49" alt="Sybase SAP"></img>
                        </div>
                        
                        <div class="col-sm-3 homepage_logo">
                            <img src={powerbuilder_logo} width="100" height="100" alt="Powerbuilder"></img>
                        </div>
                    </div>
                </div>
                


            </div>
        );
    }
}

export default Homepage;


// WEBPACK FOOTER //
// ./src/components/pages/homePage.js